import { Constants } from "@eagerdog/constants";

/** AKC agility levels that require an agility jump height before they can be entered. */
export const AKC_AGILITY_JUMP_HEIGHT_LEVELS: string[] = [
  Constants.dog_class_element_level.novice_a,
  Constants.dog_class_element_level.novice_b,
  Constants.dog_class_element_level.novice_preferred,
  Constants.dog_class_element_level.akc_open,
  Constants.dog_class_element_level.open_preferred,
  Constants.dog_class_element_level.excellent,
  Constants.dog_class_element_level.excellent_preferred,
  Constants.dog_class_element_level.master,
  Constants.dog_class_element_level.master_preferred,
  Constants.dog_class_element_level.t2b,
  Constants.dog_class_element_level.t2b_preferred,
  Constants.dog_class_element_level.premier_standard,
  Constants.dog_class_element_level.premier_standard_preferred,
  Constants.dog_class_element_level.premier_jww,
  Constants.dog_class_element_level.premier_jww_preferred,
];

/** Preferred classes that jump. Preferred Novice has no jumps. */
export const AKC_PREFERRED_OBEDIENCE_LEVELS: string[] = [
  Constants.dog_class_element_level.preferred_open,
  Constants.dog_class_element_level.preferred_utility,
];

export const UKC_RALLY_JUMP_HEIGHT_LEVELS: string[] = [
  // canonical levels (section stored separately)
  Constants.dog_class_element_level.ro3,
  Constants.dog_class_element_level.rom,
  // legacy "RO3 A" style levels
  Constants.dog_class_element_level.ro3_a,
  Constants.dog_class_element_level.ro3_b,
  Constants.dog_class_element_level.rom_a,
  Constants.dog_class_element_level.rom_b,
];

export const UKC_OBEDIENCE_JUMP_HEIGHT_LEVELS: string[] = [
  Constants.dog_class_element_level.beginner_novice,
  Constants.dog_class_element_level.novice,
  Constants.dog_class_element_level.novice_a,
  Constants.dog_class_element_level.novice_b,
  Constants.dog_class_element_level.novice_c,
  Constants.dog_class_element_level.advance_novice,
  Constants.dog_class_element_level.open_a,
  Constants.dog_class_element_level.open_b,
  Constants.dog_class_element_level.graduate_novice,
  Constants.dog_class_element_level.graduate_open,
  Constants.dog_class_element_level.versatility,
  Constants.dog_class_element_level.utility_a,
  Constants.dog_class_element_level.utility_b,
];

export const UKC_PRECISION_COURSING_HEIGHT_LEVELS: string[] = [
  Constants.dog_class_element_level.dash,
  Constants.dog_class_element_level.steeplechase,
];

export const UKC_NOSEWORK_FINAL_RESPONSE_LEVELS: string[] = [
  Constants.dog_class_element_level.master,
  Constants.dog_class_element_level.elite,
];
